export default __webpack_public_path__ + "static/devProcess-1a7b6d42582e637c4cc451607af2eb1f.jpg";